<div class="flex flex-column p-box-36 gap-6">
  <div class="flex flex-row justify-between items-center">
    <div class="flex flex-row gap-4">
      <div class="icon-container-outlined"><mat-icon class="material-symbols-outlined">notification_add</mat-icon></div>
      <div class="flex flex-column gap-2">
        <div class="mat-headline-large">Notification permission request</div>
        <div class="mat-body-medium">A notification permission request is required because browsers, operating systems, and app platforms don’t allow websites or apps to send push notifications to a user without explicit consent.</div>
      </div>
    </div>
  </div>
  <mat-divider></mat-divider>
  <div class="flex flex-row gap-2 items-center">
    <div class="steps-indicator mat-body-small">1</div>
    <div>Please provide a question that will be displayed to users before requesting notification permissions.</div>
  </div>
  <form [formGroup]="notificationForm" class="basis-75">
    <mat-form-field appearance="outline">
      <mat-label>Notification Request Question</mat-label>
      <textarea matInput [formControl]="notificationForm.controls.question"
        placeholder="e.g., 'Would you like to receive notifications about special offers and updates?'" rows="4"
        maxlength="500">
      </textarea>
      <mat-hint align="start">Be clear, give the benefit, keep it short, and sound friendly.</mat-hint>
      <mat-hint align="end" >
        {{ notificationForm.controls.question.value?.length || 0 }}/500
      </mat-hint>

      <!-- Error messages -->
      @if (notificationForm.controls.question.hasError('required') && notificationForm.controls.question.touched) {
        <mat-error
          >
          A notification request question is required
        </mat-error>
      }
      @if (notificationForm.controls.question.hasError('minlength') && notificationForm.controls.question.touched) {
        <mat-error
          >
          Question must be at least 10 characters long
        </mat-error>
      }
      @if (notificationForm.controls.question.hasError('maxlength') && notificationForm.controls.question.touched) {
        <mat-error
          >
          Question cannot exceed 500 characters
        </mat-error>
      }
    </mat-form-field>
  </form>
  <mat-divider></mat-divider>
  <div class="flex flex-column hint-container grow">
    <div class="flex flex-row items-center gap-2">
      <mat-icon class="material-symbols-outlined">lightbulb</mat-icon>
      <div class="mat-title-medium font-weight-bold">Best Practice</div>
    </div>
    <ul class="mat-body-medium">
      <li>Be clear about what notifications will include</li>
      <li>Explain the benefit to the user (e.g., "stay updated on exclusive offers")</li>
      <li>Keep the question concise but informative</li>
      <li>Use friendly, conversational language</li>
      <li>Consider mentioning notification frequency (daily, weekly, etc.)</li>
    </ul>
  </div>
  <mat-divider></mat-divider>
  <div class="flex flex-row gap-3">
    <button matButton="outlined" (click)="onClose()">Cancel</button>
    <button matButton="filled" (click)="onUpdate()" [disabled]="notificationForm.invalid">
      Apply settings
    </button>
  </div>
</div>
